// @ts-nocheck
(function () {
  'use strict';

  function initQuiz(el) {
    var questions    = Array.from(el.querySelectorAll('.quiz__question'));
    var progressFill = el.querySelector('.quiz__progress-fill');
    var stepLabel    = el.querySelector('.quiz__step-current');
    var hintEl       = el.querySelector('.quiz__hint');
    var btnNext      = el.querySelector('.quiz__btn-next');
    var btnBack      = el.querySelector('.quiz__btn-back');
    var card         = el.querySelector('.quiz__card');
    var loadingEl    = el.querySelector('.quiz__loading');
    var optinEl      = el.querySelector('[data-quiz-optin]');
    var optinForm    = el.querySelector('.quiz__optin-form');
    var optinEmail   = el.querySelector('[data-quiz-optin-email]');
    var optinError   = el.querySelector('[data-quiz-optin-error]');
    var optinSkip    = el.querySelector('[data-quiz-optin-skip]');
    var couponEl      = el.querySelector('[data-quiz-coupon]');
    var couponCopy    = el.querySelector('[data-quiz-coupon-copy]');
    var couponResults = el.querySelector('[data-quiz-coupon-results]');
    var couponCode    = couponEl ? (couponEl.dataset.couponCode || '').trim() : '';
    var total        = questions.length;
    var nextText     = btnNext ? (btnNext.dataset.next   || 'Next')           : 'Next';
    var finishText   = btnNext ? (btnNext.dataset.finish || 'See My Results') : 'See My Results';

    // Config from data attributes on [data-quiz]
    var resultsPage = el.dataset.resultsPage || '';
    var klaviyoKey    = el.dataset.klaviyoKey    || '';
    var klaviyoListId = el.dataset.klaviyoListId || '';

    // answers[stepNumber]      = array of metafield values (used to fetch results)
    // answerLabels[stepNumber] = array of option display text (used on the results page and sent to Klaviyo)
    var answers      = {};
    var answerLabels = {};
    var questionText = {};
    var resultsTags  = {};
    var step    = 1;
    var going   = false;

    questions.forEach(function (q) {
      var n = +q.dataset.step;
      questionText[n] = q.dataset.question || '';
      if (q.dataset.showOnResults === 'true') {
        resultsTags[n] = q.dataset.resultsTag || '';
      }
    });

    function getQ(n) {
      return questions.find(function (q) { return +q.dataset.step === n; });
    }

    function isMultiple(qEl) {
      return qEl.dataset.type === 'checkbox';
    }

    function hasAnswer(n) {
      return answers[n] && answers[n].length > 0;
    }

    function showStep(n) {
      if (n < 1 || n > total) return;

      questions.forEach(function (q) { q.classList.remove('is-active'); });

      var qEl = getQ(n);
      if (qEl) qEl.classList.add('is-active');

      step  = n;
      going = false;

      if (progressFill) progressFill.style.width = ((n / total) * 100) + '%';
      if (stepLabel)    stepLabel.textContent = n;
      if (hintEl && qEl) hintEl.textContent = qEl.dataset.hint || 'Select one';
      if (btnBack) btnBack.hidden = n === 1;

      if (btnNext && qEl) {
        btnNext.hidden      = false;
        btnNext.disabled    = !hasAnswer(n);
        btnNext.textContent = (n === total) ? finishText : nextText;
      }
    }

    function advance() {
      if (step < total) {
        showStep(step + 1);
      } else {
        showOptin();
      }
    }

    function recordAnswers(qEl, sel) {
      var n = +qEl.dataset.step;
      answers[n] = sel.map(function (o) {
        return o.dataset.mfValue || '';
      }).filter(Boolean);
      answerLabels[n] = sel.map(function (o) {
        return o.dataset.optionText || '';
      }).filter(Boolean);
    }

    function onOptionClick(qEl, optEl) {
      var multi = isMultiple(qEl);

      if (multi) {
        optEl.classList.toggle('is-selected');
        var sel = Array.from(qEl.querySelectorAll('.quiz__option.is-selected'));
        recordAnswers(qEl, sel);
        if (btnNext) btnNext.disabled = !hasAnswer(+qEl.dataset.step);
      } else {
        if (going) return;
        going = true;

        qEl.querySelectorAll('.quiz__option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        optEl.classList.add('is-selected');
        recordAnswers(qEl, [optEl]);
        if (btnNext) btnNext.disabled = false;

        setTimeout(advance, 340);
      }
    }

    // Return all unique non-empty metafield values across all answers
    function getAllValues() {
      var seen = {}, result = [];
      Object.keys(answers).forEach(function (n) {
        answers[n].forEach(function (v) {
          if (v && !seen[v]) { seen[v] = true; result.push(v); }
        });
      });
      return result;
    }

    // { "Question text": "Answer 1, Answer 2" } for each answered question
    function getQuizProperties() {
      var props = {};
      Object.keys(answerLabels).forEach(function (n) {
        var q      = questionText[n];
        var labels = answerLabels[n];
        if (q && labels && labels.length) props[q] = labels.join(', ');
      });
      return props;
    }

    // Array of { tag, answer } for questions flagged to show on the results page
    function getResultsSummary() {
      var summary = [];
      Object.keys(resultsTags).forEach(function (n) {
        var labels = answerLabels[n];
        if (labels && labels.length) {
          summary.push({ tag: resultsTags[n], answer: labels.join(', ') });
        }
      });
      return summary;
    }

    function showOptin() {
      if (card)    card.hidden    = true;
      if (optinEl) optinEl.hidden = false;
      if (optinEmail) optinEmail.focus();
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function setOptinError(message) {
      if (optinError) optinError.textContent = message || '';
      if (optinEmail) optinEmail.classList.toggle('is-error', !!message);
    }

    function withTimeout(promise, ms) {
      return Promise.race([
        promise,
        new Promise(function (resolve) { setTimeout(resolve, ms); })
      ]);
    }

    // Fire-and-forget: log the quiz answers to Klaviyo as an event tied to this email.
    // Independent of the actual list subscription handled by subscribeToKlaviyo() below.
    function trackQuizToKlaviyo(email) {
      if (!klaviyoKey || !email) return;

      var properties = getQuizProperties();
      if (couponCode) properties['Quiz Coupon Code'] = couponCode;

      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: properties,
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Completed Hair Quiz' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: properties
                }
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) {
          response.text().then(function (text) {
            console.error('Quiz Klaviyo event tracking failed:', response.status, text);
          }).catch(function () {});
        }
      }).catch(function (err) {
        console.error('Quiz Klaviyo event tracking request errored:', err);
      });
    }

    // Subscribes the email to the configured Klaviyo list directly (bypasses Shopify's
    // /contact endpoint entirely, so its bot-protection challenge never triggers).
    function subscribeToKlaviyo(email) {
      if (!klaviyoKey || !klaviyoListId || !email) return Promise.resolve();

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: klaviyoListId
              }
            }
          }
        }
      };

      var request = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) {
          response.text().then(function (text) {
            console.error('Quiz Klaviyo subscription failed:', response.status, text);
          }).catch(function () {});
        }
      }).catch(function (err) {
        console.error('Quiz Klaviyo subscription request errored:', err);
      });

      return withTimeout(request, 2500);
    }

    function showCoupon() {
      if (optinEl)  optinEl.hidden  = true;
      if (couponEl) couponEl.hidden = false;
    }

    function copyCouponCode() {
      var restore = function () {
        setTimeout(function () {
          couponCopy.classList.remove('is-copied');
          couponCopy.textContent = couponCopy.dataset.copyLabel || 'Copy';
        }, 1800);
      };
      var onCopied = function () {
        couponCopy.classList.add('is-copied');
        couponCopy.textContent = couponCopy.dataset.copiedLabel || 'Copied';
        restore();
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(couponCode).then(onCopied).catch(onCopied);
        return;
      }

      var temp = document.createElement('input');
      temp.value = couponCode;
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); } catch (e) { /* clipboard unsupported */ }
      document.body.removeChild(temp);
      onCopied();
    }

    function goToResults() {
      if (optinEl)   optinEl.hidden   = true;
      if (couponEl)  couponEl.hidden  = true;
      if (loadingEl) loadingEl.hidden = false;

      var vals    = getAllValues();
      var summary = getResultsSummary();

      var params = [];
      if (vals.length)    params.push('v=' + vals.map(encodeURIComponent).join(','));
      if (summary.length) params.push('rt=' + encodeURIComponent(JSON.stringify(summary)));

      var url = resultsPage
        ? resultsPage + (params.length ? '?' + params.join('&') : '')
        : '/collections/all';

      setTimeout(function () { window.location.href = url; }, 700);
    }

    // Bind option clicks
    questions.forEach(function (qEl) {
      qEl.querySelectorAll('.quiz__option').forEach(function (optEl) {
        optEl.addEventListener('click', function () { onOptionClick(qEl, optEl); });
      });
    });

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        if (!btnNext.disabled && !btnNext.hidden) advance();
      });
    }

    if (btnBack) {
      btnBack.addEventListener('click', function () {
        if (step > 1) showStep(step - 1);
      });
    }

    if (optinForm) {
      optinForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var email = optinEmail ? optinEmail.value.trim() : '';

        if (!email) {
          setOptinError('Please enter your email address.');
          if (optinEmail) optinEmail.focus();
          return;
        }

        if (!isValidEmail(email)) {
          setOptinError('Please enter a valid email address.');
          if (optinEmail) optinEmail.focus();
          return;
        }

        setOptinError('');

        var submitBtn = optinForm.querySelector('.quiz__optin-submit');
        if (submitBtn) submitBtn.disabled = true;

        trackQuizToKlaviyo(email);

        subscribeToKlaviyo(email).then(function () {
          if (couponCode) showCoupon(); else goToResults();
        });
      });
    }

    if (optinEmail) {
      optinEmail.addEventListener('input', function () {
        setOptinError('');
      });
    }

    if (optinSkip) {
      optinSkip.addEventListener('click', function () {
        goToResults();
      });
    }

    if (couponCopy) {
      couponCopy.addEventListener('click', copyCouponCode);
    }

    if (couponResults) {
      couponResults.addEventListener('click', function () {
        goToResults();
      });
    }

    showStep(1);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  });
})();
